module.exports = __webpack_public_path__ + "static/media/infografico-mobile.d596e654.png";